/* Cuadrícula de la portada, igual que el Store de alejandrocartagena.com:
   - Escritorio: al mover el cursor sobre la foto se recorren las fotos del libro
     (barrido) y arriba aparecen las rayitas; al salir vuelve a la primera.
   - Móvil: flechas ‹ › y deslizar con el dedo.
   - «Add to cart — $precio» agrega al carrito de Shopify sin salir de la página
     y muestra «Added» un momento, como en .com. No toca el JS del carrito de Taste. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 63.9375em)');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function onMq(fn) {
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', fn);
    else if (MOBILE.addListener) MOBILE.addListener(fn);
  }

  function setup(box) {
    var srcs = (box.getAttribute('data-srcs') || '').split(/\s+/).filter(Boolean);
    var n = srcs.length;
    var img = box.querySelector('img');
    if (n < 2 || !img) return;
    var title = box.getAttribute('data-title') || '';
    var ticks = box.querySelectorAll('.shop-scrub-ticks i');
    var i = 0;
    var warmed = {};
    var touchX = null;

    function warm(j) {
      j = ((j % n) + n) % n;
      if (warmed[j]) return;
      warmed[j] = true;
      var im = new Image();
      im.decoding = 'async';
      im.src = srcs[j];
    }

    function show(j) {
      j = ((j % n) + n) % n;
      if (j === i) return;
      i = j;
      img.src = srcs[i];
      img.alt = title + ' ' + (i + 1) + '/' + n;
      for (var k = 0; k < ticks.length; k++) ticks[k].className = k === i ? 'on' : '';
      if (box.classList.contains('is-arrows')) {
        img.classList.remove('shop-fade');
        void img.offsetWidth;
        img.classList.add('shop-fade');
      }
      warm(i + 1);
      warm(i - 1);
    }

    function mode() {
      var m = MOBILE.matches;
      box.classList.toggle('is-scrub', !m);
      box.classList.toggle('is-arrows', m);
    }
    mode();
    onMq(mode);
    warm(1);
    warm(-1);

    box.addEventListener('mouseenter', function () {
      if (!box.classList.contains('is-scrub')) return;
      warm(i);
      warm(i + 1);
      warm(i - 1);
    });
    box.addEventListener('mousemove', function (e) {
      if (!box.classList.contains('is-scrub')) return;
      var r = box.getBoundingClientRect();
      if (r.width <= 0) return;
      var x = Math.min(Math.max(e.clientX - r.left, 0), r.width - 0.001);
      show(Math.min(n - 1, Math.max(0, Math.floor((x / r.width) * n))));
    });
    box.addEventListener('mouseleave', function () {
      if (box.classList.contains('is-scrub')) show(0);
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
    });
    box.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      touchX = null;
    });

    var prev = box.querySelector('.shop-arrow--prev');
    var next = box.querySelector('.shop-arrow--next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(i + 1); });
  }

  function cartLabel(count) {
    var el = document.getElementById('cart-icon-bubble');
    if (el) el.textContent = 'Cart' + (count ? ' (' + count + ')' : '');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-com-add]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-com-add');
    var label = b.getAttribute('data-label') || b.textContent;
    b.textContent = 'Added';
    b.classList.add('shop-buy--added');
    window.setTimeout(function () {
      b.textContent = label;
      b.classList.remove('shop-buy--added');
    }, 900);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartLabel(c.item_count); })
      .catch(function () {
        window.location.href = root + 'cart/add?id=' + encodeURIComponent(id) + '&quantity=1';
      });
  });

  function init() {
    var boxes = document.querySelectorAll('[data-com-carousel]');
    for (var k = 0; k < boxes.length; k++) setup(boxes[k]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
